import React from 'react'

import { Portlet } from '_zari/core'

import * as Forms from './forms'

const NuevoSinDocumentoSection = ({ idTituloViatico, mostrarListaSection, editarData, idSocio }) => {
  return (
    <Portlet>
      <Portlet.Header title='Nuevo sin documento' hideClose />
      <Portlet.Body>
        <Forms.MainForm
          idTituloViatico={idTituloViatico}
          idSocio={idSocio}
          mostrarListaSection={mostrarListaSection}
          editarData={editarData}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoSinDocumentoSection)
